<template>
  <v-card>
    <v-card-title>
      <div class="mr-2">{{ $t('settings.stunServers.title') }}</div>
    </v-card-title>
    <v-card-text class="pr-8">
      <v-text-field
        v-model="stunServers"
        :label="$t('settings.stunServers.label')"
        :rules="stunServerRules"
      ></v-text-field>
      <p class="caption">
        {{ $t('settings.stunServers.caption1') }}<br />
        {{ $t('settings.stunServers.caption2') }}<br />
        {{ $t('settings.stunServers.caption3') }}
      </p>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text @click="save" :disabled="!isValid" class="save-btn">
        {{ $t('settings.stunServers.save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import stunservers from '@/sipua/stunservers'
import events from '@/store/events'

export default {
  name: 'settings-stun-servers',
  data () {
    return {
      stunServers: '',
      stunServerRules: [
        v => {
          if (!v) return true
          const servers = v.split(',').map(s => s.trim())
          const regex = /^(stun|stuns):[a-zA-Z0-9.-]+(:[0-9]{1,5})?$/
          return servers.every(server => regex.test(server)) || this.$t('settings.stunServers.invalidFormat')
        }
      ]
    }
  },
  created () {
    this.stunServers = stunservers.get() || ''
  },
  computed: {
    isValid () {
      if (!this.stunServers) {
        return true
      }
      const servers = this.stunServers.split(',').map(s => s.trim())
      const regex = /^(stun|stuns):[a-zA-Z0-9.-]+(:[0-9]{1,5})?$/
      return servers.every(server => regex.test(server))
    }
  },
  methods: {
    save () {
      stunservers.set(this.stunServers)
      events.pubNotify({ text: this.$t('settings.notify.stunServersSaved'), status: 'success' })
      this.$router.go(0)
    }
  }
}
</script>
